// extracted by mini-css-extract-plugin
export default {"blogs":"Blogs_blogs__4rpvC","message":"Blogs_message__7xVxL","search":"Blogs_search__3snrE","tags":"Blogs_tags__UJQac","active":"Blogs_active__nGbYD","extra":"Blogs_extra__vT7t0"};